import React, { useState } from 'react';

export function formatDate(date) {
    const formattedDate = new Date(date);
    const mm = String(formattedDate.getMonth() + 1).padStart(2, '0');
    const dd = String(formattedDate.getDate()).padStart(2, '0');
    const yyyy = formattedDate.getFullYear();
    return mm + '/' + dd + '/' + yyyy;
}